import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Dice } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Dice"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "dice"
    }}>{`Dice`}</h1>
    <Dice mdxType="Dice" />
    <p>{`This simulation just throws a certain number of dice and tallies the result over time.
For just one die, the expected results are that we'll get the same number of rolls for each value.
For several dice, the bars are expected to follow a nice bell curve.`}</p>
    <p>{`But actually, the shape of the results is pretty different from that. Random functions are not perfect.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      